/* unplugin-vue-components disabled */import script from "./ask-list.vue?vue&type=script&setup=true&lang=js"
export * from "./ask-list.vue?vue&type=script&setup=true&lang=js"

import "./ask-list.vue?vue&type=style&index=0&id=41ef1b32&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ef1b32"]])

export default __exports__